import { render, staticRenderFns } from "./initial-setting.vue?vue&type=template&id=e4f8f1f8&scoped=true&"
import script from "./initial-setting.vue?vue&type=script&lang=ts&"
export * from "./initial-setting.vue?vue&type=script&lang=ts&"
import style0 from "./initial-setting.vue?vue&type=style&index=0&id=e4f8f1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f8f1f8",
  null
  
)

export default component.exports